import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'prgov-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnInit {
  @Input() loading = false;
  @Input() bgLight = false;
  @Input() text: string;
  @Input() overlayOpacity = false;
  constructor() {}

  ngOnInit() {}
  getOverlayStyles() {
    let styles = '';
    styles = this.bgLight ? 'inverse' : '';
    styles += this.overlayOpacity ? ' opacity' : '';
    return styles;
  }
}
